import { render } from "./GamingCorner.vue?vue&type=template&id=51c1cf61"
import script from "./GamingCorner.vue?vue&type=script&lang=js"
export * from "./GamingCorner.vue?vue&type=script&lang=js"

import "./GamingCorner.vue?vue&type=style&index=0&id=51c1cf61&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__